<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.chargeback.date') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.chargeback.reason-code') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.chargeback.type') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.chargeback.reason-message') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.chargeback.status') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.chargeback.time') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__group">
      <div class="transaction-item-info__row"></div>
      <div class="transaction-item-info__row"></div>
      <div class="transaction-item-info__row"></div>
    </div>
    <div class="transaction-item-info__group">
      <div class="transaction-item-info__row"></div>
      <div class="transaction-item-info__row"></div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemChargebackInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
